import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AreaPreference } from '../models/areaPreference';
import { ExtraAudit } from '../models/extraAudit';
import { ScheduledDate } from '../models/scheduledDate';

@Injectable({
  providedIn: 'root',
})
export class CustomerSchedulingService {
  constructor(private http: HttpClient) {}

  getSettings() {
    return this.http.get<AreaPreference[]>(`${environment.apiBase}/customerScheduling/settings`);
  }

  getSettingsByToken(token: string) {
    return this.http.get<AreaPreference[]>(`${environment.apiBase}/customerScheduling/settings/${token}`);
  }

  getScheduledDates() {
    return this.http.get<ScheduledDate[]>(`${environment.apiBase}/customerScheduling/scheduledDates`);
  }

  getScheduledDatesByToken(token: string) {
    return this.http.get<ScheduledDate[]>(`${environment.apiBase}/customerScheduling/scheduledDates/${token}`);
  }

  requestAudit(extraAudit: ExtraAudit) {
    return this.http.post(`${environment.apiBase}/customerScheduling/extraAudit`, extraAudit);
  }

  requestAuditByToken(token: string, extraAudit: ExtraAudit) {
    return this.http.post(`${environment.apiBase}/customerScheduling/extraAudit/${token}`, extraAudit);
  }
}
